var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2600_40419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 1.6665C16.8877 1.6665 17.0996 1.7543 17.2559 1.91058C17.4122 2.06686 17.5 2.27882 17.5 2.49984V17.4998C17.5 17.7208 17.4122 17.9328 17.2559 18.0891C17.0996 18.2454 16.8877 18.3332 16.6667 18.3332H3.33333C3.11232 18.3332 2.90036 18.2454 2.74408 18.0891C2.5878 17.9328 2.5 17.7208 2.5 17.4998V2.49984C2.5 2.27882 2.5878 2.06686 2.74408 1.91058C2.90036 1.7543 3.11232 1.6665 3.33333 1.6665H16.6667ZM15.8333 3.33317H4.16667V16.6665H15.8333V3.33317ZM13.3333 13.3332V14.9998H6.66667V13.3332H13.3333ZM10 4.99984C10.8841 4.99984 11.7319 5.35103 12.357 5.97615C12.9821 6.60127 13.3333 7.44912 13.3333 8.33317C13.3333 9.21723 12.9821 10.0651 12.357 10.6902C11.7319 11.3153 10.8841 11.6665 10 11.6665C9.11594 11.6665 8.2681 11.3153 7.64298 10.6902C7.01786 10.0651 6.66667 9.21723 6.66667 8.33317C6.66667 7.44912 7.01786 6.60127 7.64298 5.97615C8.2681 5.35103 9.11594 4.99984 10 4.99984ZM10 6.6665C9.55797 6.6665 9.13405 6.8421 8.82149 7.15466C8.50893 7.46722 8.33333 7.89114 8.33333 8.33317C8.33333 8.7752 8.50893 9.19912 8.82149 9.51168C9.13405 9.82424 9.55797 9.99984 10 9.99984C10.442 9.99984 10.866 9.82424 11.1785 9.51168C11.4911 9.19912 11.6667 8.7752 11.6667 8.33317C11.6667 7.89114 11.4911 7.46722 11.1785 7.15466C10.866 6.8421 10.442 6.6665 10 6.6665Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2600_40419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportIcon);
export default __webpack_public_path__ + "static/media/passport_icon.3fe1162360aa60bc15fc5e4608459f42.svg";
export { ForwardRef as ReactComponent };